function isMergeableObject(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

export default function deepMerge(target, source) {
  if (!isMergeableObject(source)) return target;

  for (const key of Object.keys(source)) {
    const sourceValue = source[key];
    const targetValue = target[key];

    if (isMergeableObject(sourceValue)) {
      target[key] = deepMerge(
        isMergeableObject(targetValue) ? targetValue : {},
        sourceValue
      );
    } else {
      target[key] = sourceValue;
    }
  }

  return target;
}
